<template>
  <div class="step-two px-[20px]">
    <div class="form-wrapper grid grid-cols-4-default gap-5 mb-5">
      <!-- Number Of Shareholders -->
      <div class="col-span-4 lg:col-span-2">
        <!-- <label class="font-body text-base text-gray-900  " for="numberOfShareholders"
          >{{ translations.text.number_of_shareholders }}<span class="text-orange ml-1">*</span></label
        >
        <div class="my-2">
          <span class="select is-fullwidth">
            <select
              v-validate="'required|min_value:1'"
              :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('numberOfShareholders') }"
              :data-vv-as="translations.text.number_of_shareholders"
              name="numberOfShareholders"
              v-model="data.numberOfShareholders"
              class="text-base text-gray-900 font-semibold rtl:bg-left"
            >
              <option value="" selected hidden>{{ translations.text.number_of_shareholders }}</option>
              <option v-for="index in 4" :value="index" :key="index">{{ index }}</option>
            </select>
          </span>
          <span v-show="errors.has('numberOfShareholders')" class="font-body text-xs text-orange font-semibold">{{ errors.first('numberOfShareholders') }}</span>
        </div> -->
        <Select
          :key="translations.text.number_of_shareholders"
          v-model="data.numberOfShareholders"
          name="numberOfShareholders"
          :rules="{
            min_value: 1,
            required: true,
          }"
          :placeholder="translations.text.number_of_shareholders"
          :options="[1, 2, 3, 4]"
          :label="translations.text.number_of_shareholders"
          :coerce-to-number="true"
        />
      </div>
      <!-- Number Of Directors -->
      <div class="col-span-4 lg:col-span-2">
        <!-- <label class="font-body text-base text-gray-900  " for="numberOfDirectors"
          >{{ translations.text.number_of_directors }}<span class="text-orange ml-1">*</span></label
        >
        <div class="my-2">
          <span class="select is-fullwidth">
            <select
              v-validate="'required|min_value:1'"
              :class="{ 'ring-1 ring-orange bg-gray-100 select-placeholder': errors.has('numberOfDirectors') }"
              :data-vv-as="translations.text.number_of_directors"
              name="numberOfDirectors"
              v-model="data.numberOfDirectors"
              class="text-base text-gray-900 font-semibold rtl:bg-left"
            >
              <option value="" selected hidden>{{ translations.text.number_of_directors }}</option>
              <option v-for="index in 4" :value="index" :key="index">{{ index }}</option>
            </select>
          </span>
          <span v-show="errors.has('numberOfDirectors')" class="font-body text-xs text-orange font-semibold">{{ errors.first('numberOfDirectors') }}</span>
        </div> -->
        <Select
          :key="translations.text.number_of_directors"
          v-model="data.numberOfDirectors"
          name="numberOfDirectors"
          :rules="{
            min_value: 1,
            required: true,
          }"
          :placeholder="translations.text.number_of_directors"
          :options="[1, 2, 3, 4]"
          :label="translations.text.number_of_directors"
          :coerce-to-number="true"
        />
      </div>
      <div
        class="col-span-4 lg:col-span-4 shareholders-buttons-wrapper grid grid-cols-4-default gap-5 overflow-x-auto select-none"
        id="shareholders-container"
        v-show="data.numberOfShareholders"
      >
        <div
          @click="changeShareholder(shareholder)"
          :class="[
            `shareholder-${shareholder}`,
            {
              'border-green text-green bg-green-500 bg-opacity-10': validationStatesShareholder[shareholder - 1],
              ' bg-gray-400': !validationStatesShareholder[shareholder - 1],
              'opacity-100 border-blue ': activeShareholder === shareholder,
              'opacity-60': activeShareholder != shareholder,
              'bg-red-500 text-red bg-opacity-10 border-red': isContinuePressedWithShareholderErrors && !validationStatesShareholder[shareholder - 1],
            },
          ]"
          class="shareholder-title w-52 h-9 flex items-center font-display font-bold text-[18px] justify-center border rounded-md cursor-pointer"
          v-for="shareholder in data.numberOfShareholders"
          :key="shareholder"
          :ref="`shareholder-${shareholder}`"
        >
          {{ `Shareholder-${shareholder}` }}
        </div>
      </div>
      <hr class="col-span-4 lg:col-span-4 border-gray-300" v-show="data.numberOfShareholders" />
      <div class="col-span-4 lg:col-span-4 shareholder-form">
        <ShareholderDirectorForm
          v-show="activeShareholder == sh"
          v-for="sh in data.numberOfShareholders"
          :key="'shareholder' + sh"
          :translations="translations"
          :accountType="accountType"
          :index="sh"
          :dataArray="data.shareholders"
          :type="'Shareholder'"
          :prefilledTestData="prefilledTestData"
          :testData="testData"
          @ChangeShareholderData="shareholderDataChange"
          :isContinuePressedWithErrors="isContinuePressedWithShareholderErrors"
        />
      </div>
      <div
        v-show="data.numberOfDirectors"
        class="col-span-4 lg:col-span-4 directors-buttons-wrapper grid grid-cols-4-default gap-5 overflow-x-auto select-none"
        id="directors-container"
      >
        <div
          @click="changeDirector(index)"
          :class="[
            `director-${index}`,
            {
              'border-green text-green bg-green-500 bg-opacity-10': validationStatesDirector[index - 1],
              'bg-gray-400': !validationStatesDirector[index - 1],
              'opacity-100 border-blue ': activeDirector === index,
              'opacity-60': activeDirector != index,
              'bg-red-500 text-red bg-opacity-10 border-red': isContinuePressedWithDirectorErrors && !validationStatesDirector[index - 1],
            },
          ]"
          class="director-title w-52 h-9 flex items-center font-display font-bold text-[18px] justify-center border rounded-md cursor-pointer"
          v-for="index in data.numberOfDirectors"
          :key="index"
          :ref="`director-${index}`"
        >
          {{ `Director-${index}` }}
        </div>
      </div>
      <hr class="col-span-4 lg:col-span-4 border-gray-300" v-show="data.numberOfDirectors" />
      <div class="col-span-4 lg:col-span-4 directors-wrapper">
        <ShareholderDirectorForm
          v-show="data.numberOfDirectors && activeDirector == d"
          v-for="d in data.numberOfDirectors"
          :translations="translations"
          :accountType="accountType"
          :key="'director' + d"
          :index="d"
          :dataArray="data.directors"
          :type="'Director'"
          :prefilledTestData="prefilledTestData"
          :testData="testData"
          @ChangeDirectorData="directorDataChange"
          :isContinuePressedWithErrors="isContinuePressedWithDirectorErrors"
        />
      </div>
    </div>
    <div class="button-wrapper flex justify-between md:justify-start gap-[5%]">
      <Button mode="primary-outlined" customClasses="max-w-[185px]" @click="changePage()">
        {{ $t('previous') }}
      </Button>
      <Button @click="changePage(true)" customClasses="max-w-[185px]">
        {{ $t('continue').tTitle() }}
      </Button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ShareholderDirectorForm from '../registerComponents/ShareholderDirectorForm.vue'
import Button from '../reusableComponents/Button.vue'
import Select from '../reusableComponents/Select.vue'

export default {
  components: {
    ShareholderDirectorForm,
    Button,
    Select,
  },
  props: {
    accountType: String,
    activeStep: Number,
    isCompany: Boolean,
    translations: Object,
    formData: Object,
    upgrade: Boolean,
    prefilledTestData: Boolean,
    testData: Object,
  },
  data() {
    return {
      page: this.activeStep,
      activeShareholder: 1,
      activeDirector: 1,
      monthDayIndexes: Array.from({ length: 31 }, (v, i) => ++i),
      years: Array.from({ length: 100 }, (v, i) => moment().year() - i + 1),
      data: {
        numberOfShareholders: 0,
        numberOfDirectors: 0,
        shareholders: [{}, {}, {}, {}],
        directors: [{}, {}, {}, {}],
        ib_main_target_region: '',
      },
      proceed: false,
      validationStatesShareholder: [],
      validationStatesDirector: [],
      isContinuePressedWithShareholderErrors: false,
      isContinuePressedWithDirectorErrors: false,
    }
  },
  mounted() {
    this.dragContainer('#shareholders-container')
    this.dragContainer('#directors-container')
    this.checkForExistingData()
  },
  created() {
    if (this.formData) {
      Object.keys(this.formData).forEach(key => {
        this.data[key] = this.formData[key]
      })
    } else if (this.prefilledTestData && this.testData) {
      // make a clone object of this.testData in order to prevent it from updates coming from the child component
      const clonedTestData = JSON.parse(JSON.stringify(this.testData))
      Object.keys(clonedTestData).forEach(key => {
        this.data[key] = clonedTestData[key]
      })
    }
  },
  watch: {
    // watcher for the i18n language change
    '$i18n.locale'() {
      this.$validator.reset()
    },
    'data.numberOfShareholders'(val, OldVal) {
      // if number shareholders number is changed to a smaller number update the formData
      if (val < this.formData.numberOfShareholders || val < OldVal) {
        this.$set(this.data, 'shareholders', this.data.shareholders.slice(0, val))
        for (let i = this.data.shareholders.length; i < 4; i++) {
          this.$set(this.data.shareholders, i, {})
        }
        this.$bus.$emit('DataSubmitted', this.data)
      }
      // make activeShareholder if the previous shareholder that was active doesn't exist anymore
      if (val < this.activeShareholder) {
        this.activeShareholder = val
      }
      // remove from validationStatesShareholder the value for the shareholder that doesn't exist
      if (this.validationStatesShareholder.length > val) {
        this.validationStatesShareholder.splice(val)
      }

      if (val > OldVal) {
        this.$set(this.data, 'shareholders', this.data.shareholders.slice(0, OldVal))
        for (let i = this.data.shareholders.length; i < 4; i++) {
          this.$set(this.data.shareholders, i, {})
        }
      }
    },
    'data.numberOfDirectors'(val, OldVal) {
      // if number directors number is changed to a smaller number update the formData
      if (val < this.formData.numberOfDirectors || val < OldVal) {
        this.$set(this.data, 'directors', this.data.directors.slice(0, val))
        for (let i = this.data.directors.length; i < 4; i++) {
          this.$set(this.data.directors, i, {})
        }
        this.$bus.$emit('DataSubmitted', this.data)
      }
      // make activeDirector if the previous director that was active doesn't exist anymore
      if (val < this.activeDirector) {
        this.activeDirector = val
      }
      // remove from validationStatesDirector the value for the director that doesn't exist
      if (this.validationStatesDirector.length > val) {
        this.validationStatesDirector.splice(val)
      }
      if (val > OldVal) {
        this.$set(this.data, 'directors', this.data.directors.slice(0, OldVal))
        for (let i = this.data.directors.length; i < 4; i++) {
          this.$set(this.data.directors, i, {})
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
      BonusConfig: 'bonusconfig/all',
    }),
    companyActive() {
      this.$validator.reset()
      return this.isCompany
    },
    // find the first invalid director
    firstInvalidDirectorIndex() {
      return this.validationStatesDirector.findIndex(state => state === false)
    },
    // find the first invalid shareholder
    firstInvalidShareholderIndex() {
      return this.validationStatesShareholder.findIndex(state => state === false)
    },
  },
  methods: {
    changePage(nextStep) {
      const hasFalseShareholder = this.validationStatesShareholder.includes(false)
      const hasFalseDirector = this.validationStatesDirector.includes(false)

      if (nextStep) {
        this.$validator.validateAll().then(result => {
          if (result) {
            // number of shareholder and number of director doesn't have errors so we check the shareholderDirector component data
            if (hasFalseShareholder) {
              // to pass a props to child to revalidate again the field for shareholders if there are errors
              this.isContinuePressedWithShareholderErrors = hasFalseShareholder
              // if has shareholder with errors to check which is and to go to that one
              this.data.shareholders.forEach((shareholder, index) => {
                if (this.validationStatesShareholder[index] === false) {
                  const shareholderRef = this.$refs[`shareholder-${index + 1}`]
                  if (shareholderRef) {
                    this.activeShareholder = this.firstInvalidShareholderIndex + 1
                    shareholderRef[0].classList.add('bg-red-500', 'bg-opacity-10', 'border-red', 'text-red')
                    shareholderRef[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
                  }
                }
              })
            }
            if (hasFalseDirector) {
              // to pass a props to child to revalidate again the field for directors if there are errors
              this.isContinuePressedWithDirectorErrors = hasFalseDirector
              //  if has directors with errors to check which is and to go to that one
              this.data.directors.forEach((director, index) => {
                if (this.validationStatesDirector[index] === false) {
                  const directorRef = this.$refs[`director-${index + 1}`]
                  if (directorRef) {
                    this.activeDirector = this.firstInvalidDirectorIndex + 1
                    directorRef[0].classList.add('bg-red-500', 'bg-opacity-10', 'border-red', 'text-red')
                    directorRef[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
                  }
                }
              })
            }
            // if there are not errors go to the next step
            if (!hasFalseDirector && !hasFalseShareholder) return this.$bus.$emit('DataSubmitted', this.data), this.$bus.$emit('ChangePage', this.page + 1)
          } else {
            // number of shareholder and number of director field has errors
            if (this.errors.items.length > 0) {
              let el = document.getElementsByName(this.errors.items[0].field)[0]
              return el.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          }
        })
        // go to the previous step
      } else return this.$bus.$emit('DataSubmitted', this.data), this.$bus.$emit('ChangePage', this.page - 1)
    },
    shareholderDataChange(data) {
      // set the data that are coming from the child the emit function @ChangeShareholderData for shareholder
      this.$set(this.validationStatesShareholder, data.invalidIndex - 1, data.isValid)
      if (data && data.index && data.data) {
        // Safely set the data if everything exists
        this.$set(this.data.shareholders, data.index - 1, data.data)
      }
    },
    directorDataChange(data) {
      // set the data that are coming from the child the emit function @ChangeDirectorData for director
      this.$set(this.validationStatesDirector, data.invalidIndex - 1, data.isValid)
      if (data && data.index && data.data) {
        // Safely set the data if everything exists
        this.$set(this.data.directors, data.index - 1, data.data)
      }
    },
    changeShareholder(index) {
      this.activeShareholder = index
    },
    changeDirector(index) {
      this.activeDirector = index
    },
    checkForExistingData() {
      // is used to have the data when we go to the previous or next step
      this.formData.numberOfShareholders ? (this.data.numberOfShareholders = this.formData.numberOfShareholders) : this.data.numberOfShareholders
      this.formData.numberOfDirectors ? (this.data.numberOfDirectors = this.formData.numberOfDirectors) : this.data.numberOfDirectors
      this.formData.shareholders ? (this.data.shareholders = this.formData.shareholders) : null
      this.formData.directors ? (this.data.directors = this.formData.directors) : null
    },
  },
}
</script>
<style scoped>
.shareholders-buttons-wrapper::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.shareholders-buttons-wrapper {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.directors-buttons-wrapper::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.directors-buttons-wrapper {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
